import React from 'react';
import PropTypes from 'prop-types';
import { CHILDREN_PROP_TYPES } from 'propTypes';
import Box from '@mui/material/Box';

import LocationCardFulfillmentTypeGridItem from 'components/Location/LocationCardFulfillmentTypeGridItem';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';

const NoAsapAvailableOrderInfo = ({
  fulfillmentMethod,
  LocationCardFulfillmentHours
}) => {
  return (
    <LocationCardFulfillmentTypeGridItem>
      <Box data-testid="fulfillment-method-text">
        <MenuItemDescriptionTypography variant={ITEM_DESCRIPTION_AND_PRICES}>
          We’re not accepting {fulfillmentMethod} orders right now.
        </MenuItemDescriptionTypography>
      </Box>
      {LocationCardFulfillmentHours}
    </LocationCardFulfillmentTypeGridItem>
  );
};

NoAsapAvailableOrderInfo.propTypes = {
  fulfillmentMethod: PropTypes.string.isRequired,
  LocationCardFulfillmentHours: CHILDREN_PROP_TYPES.isRequired
};

export default NoAsapAvailableOrderInfo;
